module.exports = __webpack_public_path__ + "image/icon_tianmao.png";